export default "__VITE_ASSET__DOgIMovh__"